import { useEffect, useState } from 'react'

import {
  Button,
  EmptyState,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader
} from '@clientbase/clientbase-library'
import { Box, Skeleton, Typography, Stack } from '@mui/material'
import {
  ConstructorReceivableParams,
  ReceivablesParams
} from 'models/Receivables'
import { ReceivablesService } from 'services/ReceivablesService'

import IconContainer from 'components/IconContainer/IconContainer'
import { Table } from 'components/Table'
import { TableSkeleton } from 'components/Table/TableSkeleton'

import { formatMoney } from 'utils'
import { formatDate } from 'utils/FormatDate'

import {
  DETAIL_MODAL_HEIGHT,
  DETAIL_MODAL_MAX_WIDTH
} from '../ModalBalance/ModalBalance.constants'
import ModalChargeDetail from '../ModalChargeDetail'
import * as S from './ModalBalaceDetail.styles'
import { convertToRows } from './ModalBalaceDetail.utils'
export type Record = {
  receivable?: ReceivablesParams
}

export type ModalBalanceProps = {
  isOpen: boolean
  handleClose: () => void
  date: string
}

const HEADER = [
  { id: 'name', label: 'Cliente' },
  { id: 'dueDate', label: 'Data de Vencimento' },
  { id: 'paidDate', label: 'Data Pagamento' },
  { id: 'amountPaid', label: 'Valor Pago' },
  { id: 'fee', label: 'Tarifa bancária' },
  { id: 'amountLiquid', label: 'Valor Líquido' },
  { id: 'paymentType', label: 'Método de Pagamento' },
  { id: 'actions', label: '' }
]

export const ModalBalanceDetail = ({
  isOpen,
  handleClose,
  date
}: ModalBalanceProps) => {
  const [tableFetchLoading, setTableFetchLoading] = useState(false)
  const [records, setRecords] = useState<ConstructorReceivableParams[]>([])
  const [balance, setBalance] = useState<string>('0.0')

  const [modal, setModal] = useState({
    isOpenDetailInvoice: false,
    uuid: ''
  })

  const handleCloseModalBalance = () => {
    handleClose()
  }

  const handleOpenDetailInvoice = (uuid: string) => {
    setModal((prevState) => ({
      ...prevState,
      isOpenDetailInvoice: true,
      uuid
    }))
  }

  const handleCloseDetailInvoice = () => {
    setModal((prevState) => ({
      ...prevState,
      isOpenDetailInvoice: false,
      uuid: ''
    }))
  }
  useEffect(() => {
    if (!isOpen) return

    const getData = async () => {
      setTableFetchLoading(true)
      const { balance: BalanceResponse, details } =
        await ReceivablesService.getCalendarByDateDetails(date)

      setRecords(details)
      setBalance(BalanceResponse)
      setTableFetchLoading(false)
    }

    getData()
  }, [isOpen])

  return (
    <>
      <Modal
        handleClose={handleCloseModalBalance}
        open={isOpen}
        size="large"
        width="100%"
        maxWidth={DETAIL_MODAL_MAX_WIDTH}
        height={DETAIL_MODAL_HEIGHT}
      >
        <ModalBody
          sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
          <ModalHeader onClose={handleCloseModalBalance}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
              mr={2}
            >
              <Stack direction="row" alignItems="center" gap={2}>
                <IconContainer icon="accountBalance" />
                <Typography variant="mdBold">
                  {date ? `Recebíveis de ${formatDate(date)}` : 'Recebíveis'}
                </Typography>
              </Stack>
              {tableFetchLoading ? (
                <Skeleton
                  animation="wave"
                  variant="rounded"
                  width={140}
                  height={18}
                />
              ) : (
                <Typography variant="smBold">
                  Saldo: {formatMoney(Number(balance))}
                </Typography>
              )}
            </Stack>
          </ModalHeader>

          <ModalContent sx={{ flex: 1, minHeight: 0 }}>
            {tableFetchLoading ? (
              <TableSkeleton
                columns={8}
                rows={6}
                hidePagination
                cellRenderHint={[
                  'text',
                  'text',
                  'text',
                  'text',
                  'text',
                  'text',
                  'text',
                  'icon'
                ]}
              />
            ) : !records.length ? (
              <S.EmptyStateWrapper>
                <Box maxWidth="600px" width="100%">
                  <EmptyState
                    title="Nenhum recebível encontrado"
                    message="Não há valores a liberar para o dia selecionado."
                  />
                </Box>
              </S.EmptyStateWrapper>
            ) : (
              <S.TableWrapper>
                <Table
                  mobileCards
                  header={HEADER}
                  rows={convertToRows({ records, handleOpenDetailInvoice })}
                  rowAction={handleOpenDetailInvoice}
                  select={{ useSelect: false }}
                  hiddePagination={true}
                />
              </S.TableWrapper>
            )}
          </ModalContent>

          <ModalFooter>
            <Button variantButton="neutral" onClick={handleCloseModalBalance}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalBody>
      </Modal>

      <ModalChargeDetail
        handleCloseChargeDetail={handleCloseDetailInvoice}
        isOpenChargeDetail={modal.isOpenDetailInvoice}
        uuid={modal.uuid}
        disablePortal={false}
      />
    </>
  )
}
